import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../../sensorconfig.axios";

interface RtssReportState {
  ImpactSummary: {
    load: boolean;
    data: [];
  };
  OperatorWiseImpactSummary: {
    load: boolean;
    data: [];
  };
  SkillScoreSummary: {
    load: boolean;
    data: [];
  };
}

export const RtssReportSlice = createSlice({
  name: "RtssReport",
  initialState: {
    ImpactSummary: {
      load: false,
      data: [],
    },
    OperatorWiseImpactSummary: {
      load: false,
      data: [],
    },
    SkillScoreSummary: {
      load: false,
      data: [],
    },
  } as RtssReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getImpactSummary.pending, (state) => {
        state.ImpactSummary.load = true;
      })
      .addCase(getImpactSummary.fulfilled, (state, action) => {
        state.ImpactSummary.data = action.payload;
        state.ImpactSummary.load = false;
      })
      .addCase(getImpactSummary.rejected, (state) => {
        state.ImpactSummary.load = false;
      })
      .addCase(getOperatorWiseImpactSummary.pending, (state) => {
        state.OperatorWiseImpactSummary.load = true;
      })
      .addCase(getOperatorWiseImpactSummary.fulfilled, (state, action) => {
        state.OperatorWiseImpactSummary.data = action.payload;
        state.OperatorWiseImpactSummary.load = false;
      })
      .addCase(getOperatorWiseImpactSummary.rejected, (state) => {
        state.OperatorWiseImpactSummary.load = false;
      })
      .addCase(getSkillScoreSummary.pending, (state) => {
        state.SkillScoreSummary.load = true;
      })
      .addCase(getSkillScoreSummary.fulfilled, (state, action) => {
        state.SkillScoreSummary.data = action.payload;
        state.SkillScoreSummary.load = false;
      })
      .addCase(getSkillScoreSummary.rejected, (state) => {
        state.SkillScoreSummary.load = false;
      });
  },
});

export default RtssReportSlice.reducer;

export const getImpactSummary = createAsyncThunk(
  "RtssReport/getImpactSummary",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/get_impact_summary?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id +
          "&start_date=" +
          param.apiParam.start_date +
          "&end_date=" +
          param.apiParam.end_date
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getOperatorWiseImpactSummary = createAsyncThunk(
  "RtssReport/getOperatorWiseImpactSummary",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/get_operator_wise_impact_summary?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id +
          "&start_date=" +
          param.apiParam.start_date +
          "&end_date=" +
          param.apiParam.end_date
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getSkillScoreSummary = createAsyncThunk(
  "RtssReport/getSkillScoreSummary",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/get_operator_skill_score_summary?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id +
          "&start_date=" +
          param.apiParam.start_date +
          "&end_date=" +
          param.apiParam.end_date
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
